/** 工信部备案链接 */
export const beiAnLink = 'https://beian.miit.gov.cn/#/Integrated/index'

/** 图片预览地址前缀 */
export const imagePreFix = 'https://www.toyonia.cc'

/** 关于我们获取数据地址 */
export const aboutUsDataUrl = () => `https://www.toyonia.cc/uploads/gywm/about_us_data.json?t=${+new Date()}`

/** 关于我们移动端获取数据地址 */
export const aboutUsH5DataUrl = () => `https://www.toyonia.cc/uploads/gywm/about_us_data_h5.json?t=${+new Date()}`
